import { render, staticRenderFns } from "./importDialogNew.vue?vue&type=template&id=63595d6c&scoped=true&"
import script from "./importDialogNew.vue?vue&type=script&lang=js&"
export * from "./importDialogNew.vue?vue&type=script&lang=js&"
import style0 from "./importDialogNew.vue?vue&type=style&index=0&id=63595d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63595d6c",
  null
  
)

export default component.exports